// extracted by mini-css-extract-plugin
export default {"content":"styles_content__-QvIL","dropdownBox":"styles_dropdownBox__CoEGc","empty":"styles_empty__Pu7OQ","applyButton":"styles_applyButton__WZ2D5","rot":"styles_rot__UKake"};